import React from 'react';
import App from './views/app/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import { Provider } from 'react-redux';
import store from './redux/store';

import './assets/css/custom.scss';

import './helpers/axios';

import { createRoot } from 'react-dom/client';

import { BrowserRouter } from 'react-router';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<BrowserRouter basename={process.env.PUBLIC_URL} window={window}>
				<App />
			</BrowserRouter>
		</Provider>
	</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
if (process.env.REACT_APP_PWA_STATUS === 'true') {
	serviceWorkerRegistration.register({
		onUpdate: async (registration) => {
			if (registration && registration.waiting) {
				await registration.unregister();
				registration.waiting.postMessage({ type: 'SKIP_WAITING' });
				window.location.reload();
			}
		},
	});
} else {
	serviceWorkerRegistration.unregister();
}
